import {useEffect} from 'react';

import {hideLoader, showLoader} from '../state/ducks/global';
import {makeSelectIsLoaderVisible} from '../state/selectors/global';
import {dispatch, getState} from '../state/store';

const useLoader = (loaderName) => {
    const checkAndHideLoader = () => {
        const isLoaderVisible = makeSelectIsLoaderVisible(loaderName)(getState());

        if (isLoaderVisible) {
            dispatch(hideLoader(loaderName));
        }
    };

    useEffect(() => {
        return checkAndHideLoader; //hide loader on component unmount
    }, []);

    return {
        hideLoader: checkAndHideLoader,
        showLoader: () => dispatch(showLoader(loaderName)),
    };
};

export default useLoader;
